import { useState } from "react";
//--------------------------------------------------------------------------------------------
import TransitionWidthHeight from "src/components/common/TransitionWidthHeight";
import { useMyStore } from "src/components/main/mainStore";
import { 
    myAxios, MyFormData, 
    scroll, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function Detail({
    setUserList, 
    form, 
    history, 
    id, 

    usersList, 
    usersListMap,
    title
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const deleteComment = async e => {
        if(!window.confirm("Are you sure to delete this comment?")) return;
        const formData = new MyFormData();
        formData.append("formHashKey", form.formHashKey);
        formData.append("commentHashKey", e.currentTarget.getAttribute("hashkey"));
        formData.append("submitterEmail", form.submitterEmail);
        //----------------------------------------
        setShowLoader(true);
        const res = await myAxios("forms/approval.php", formData);
        setShowLoader(false);
        if(!res) return;
        //----------------------------------------
        setUserList(forms => forms.map(f => 
            f.formHashKey === form.formHashKey?
            res.data:
            f
        ));
    }
    const [comments, setComments] = useState("");
    const notifyUser = async() => {
        if(!window.confirm("Are you sure to notify the approver?")) return;
        const formData = new MyFormData();
        formData.append("formHashKey", form.formHashKey);
        formData.append("formId", form.id);
        formData.append("approverEmail", form.approverEmail);
        formData.append("updaterEmail", form.updaterEmail);
        //----------------------------------------
        setShowLoader(true);
        const res = await myAxios("forms/notify.php", formData)
        setShowLoader(false);
        if(!res) return;
        //----------------------------------------
        setUserList(res.data);
        history.replace(`/${title}`);
        scroll(null);
    }
    const voidUser = async() => {
        if(!window.confirm("Are you sure to void this absence request")) return;
        let voidReason = window.prompt("reason to void:");
        if(voidReason === null) return;
        while(voidReason === ""){
            window.alert("Reason is required to void.");
            voidReason = window.prompt("reason to void:");
            if(voidReason === null) return;
        }
        const formData = new MyFormData();
        formData.append("formHashKey", form.formHashKey);
        formData.append("voidReason",voidReason);
        formData.append("formId", form.id);
        formData.append("approverEmail", form.approverEmail);
        formData.append("submitterEmail", form.submitterEmail);
        formData.append("updaterEmail", form.updaterEmail);
        //----------------------------------------
        setShowLoader(true);
        const res = await myAxios("forms/voidForm.php", formData);
        setShowLoader(false);
        if(!res) return;
        //----------------------------------------
        setUserList(forms => forms.map(f => 
            f.formHashKey === form.formHashKey?
            res.data:
            f
        ));
    }
    //--------------------------------------------------------------------------------------------
    return(
        <TransitionWidthHeight 
        classNames = "cssTDTransition"
        In = {[form.submitterEmail, form.approverEmail, ...usersList.filter(u => u.forms === "approver").map(u => u.email)].includes(user.email) && history.location.pathname.split("/")[2] ===  form.formHashKey}
    >
    <div className = "border rounded px-3">
        <div className = "mt-3">
            {Object.entries(JSON.parse(form.formContent || "{}")).filter(a => a[0] !== "projectHashKey").map((a, ai) => <li key = {ai}><span className = "font-weight-bold">{a[0]}:</span> {a[1]}</li>)}
        </div>
        <div>
            <table className = "table table-responsive-xl noTopBorder">
                <tbody>
                    {form.notify?<tr>
                        <th>Notified at</th>
                        <td>{form.notify}</td>
                    </tr>:<></>}
                    {form.void === "1"?<tr>
                        <th>Void Reason</th>
                        <td>{form.voidReason}</td>
                    </tr>:<></>}
                </tbody>
            </table>
            <div className = "mt-2 h4">Comments</div>
            <table className = "table table-responsive-xl noTopBorder">
            <colgroup>
                <col/>
            </colgroup>
                <tbody>
                    <tr>
                        <th
                            style = {{
                                whiteSpace: "pre-wrap"
                            }}
                        >
                            {!form.comments?"":
                            JSON.parse(form.comments)
                            .map((comment, commentIndex) => 
                            <div key = {commentIndex} className = "mb-2">
                                <span className = "text-info">
                                    {usersListMap?.[comment.email]}
                                </span>
                                :&nbsp;{comment.value}&nbsp;
                                <span className = "text-secondary">
                                    {comment.timeStamp}
                                </span>
                                &nbsp;{comment.email === user.email?
                                <span
                                    hashkey = {comment.hashKey}
                                    email = {comment.submitterEmail}
                                    onClick = {deleteComment}
                                    className = "btn btn-danger"
                                >
                                    Delete
                                </span>:<></>}
                            </div>)}
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>
        
        {form.void === "1"?<></>:
        ([...usersList.filter(u => u.forms === "approver").map(u => u.email), form.submitterEmail].includes(user.email)?
        <div className = "text-right mb-3">
            <span className = "btn btn-danger mx-3" onClick = {voidUser}>Void</span>
            <span className = "btn btn-primary mx-3" onClick = {() => history.push(`/${title}/${id}/Edit`)}>Edit</span>
            <span className = "btn btn-info mx-3" onClick = {notifyUser}>Notify</span>
        </div>
        :<></>)
        }
        {form.void !== "1" && [...usersList.filter(u => u.forms === "approver").map(u => u.email), form.approverEmail].includes(user.email) && form.status !== "Created" && form.status !== "Saved"?<>
        <div className = "mb-3 font-weight-bold">Comments</div>
        <textarea
            className = "form-control w-100"
            rows = {4}
            value = {comments}
            onChange = {e => {setComments(e.currentTarget.value)}}
            name = "comments"
        />
        <div>
            <span
                className = {`btn btn-success m-3`}
                onClick = {async() => {
                    if(!comments){
                        window.alert("Comments are required.");
                        return;
                    }
                    if(!window.confirm("Are you sure to add this comment?")) return;
                    const formData = new MyFormData();
                    formData.append("formHashKey", form.formHashKey);
                    formData.append("comments", comments);
                    formData.append("submitterEmail", form.submitterEmail);
                    //----------------------------------------
                    setShowLoader(true);
                    const res = await myAxios("forms/approval.php", formData);
                    setShowLoader(false);
                    if(!res) return;
                    //----------------------------------------
                    setComments("");
                    setUserList(forms => forms.map(f => 
                        f.formHashKey === form.formHashKey?
                        res.data:
                        f
                    ));
                }}
            >Send</span>
        </div>
        <div>
            {!form.dateCompleted?
            <span className = {`btn btn-primary m-3`} onClick = {async() => {
                if(!window.confirm("Are you sure to set this request complete?")) return;
                const formData = new MyFormData();
                formData.append("formHashKey", form.formHashKey);
                //----------------------------------------
                setShowLoader(true);
                const res = await myAxios("forms/complete.php", formData);
                setShowLoader(false);
                if(!res) return;
                //----------------------------------------
                setUserList(forms => forms.map(f => 
                    f.formHashKey === form.formHashKey?
                    res.data:
                    f
                ));
            }}>Complete</span>
            :<></>}
        </div>
        </>:<></>}
    </div>
    </TransitionWidthHeight>
    )
}
